import type { SerializeFrom } from '@remix-run/node';
import type { loader } from '../_index.tsx';

export function getContentStructuredData(data?: SerializeFrom<typeof loader>) {
	if (!data) return {};
	const { contentPage } = data;
	const json = contentPage?.googleStructuredDataJSON;
	return {
		'script:ld+json': json ? JSON.parse(json) : {},
	};
}
